/**
 * Ryan O'Dowd
 * 2024-09-28
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = () => {
  return {
    nameWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    subTitle: {
      fontSize: '0.8em',
    },
    progressWrapper: {
      cursor: 'pointer',
    },
  };
};

export default getStyles;
